import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _extends from "@babel/runtime/helpers/esm/extends";
import { mergeToken, genComponentStyleHook } from '../../theme/internal';
import { resetComponent } from '../../style';
var genQRCodeStyle = function genQRCodeStyle(token) {
  var _extends2, _ref;
  var componentCls = token.componentCls;
  return _ref = {}, _defineProperty(_ref, componentCls, _extends(_extends({}, resetComponent(token)), (_extends2 = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: token.paddingSM,
    borderRadius: token.borderRadiusLG,
    border: token.lineWidth + "px " + token.lineType + " " + token.colorSplit,
    position: 'relative',
    width: '100%',
    height: '100%',
    overflow: 'hidden'
  }, _defineProperty(_extends2, "& > " + componentCls + "-mask", {
    position: 'absolute',
    insetBlockStart: 0,
    insetInlineStart: 0,
    zIndex: 10,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    color: token.colorText,
    lineHeight: token.lineHeight,
    background: token.QRCodeMaskBackgroundColor,
    textAlign: 'center'
  }), _defineProperty(_extends2, '&-icon', {
    marginBlockEnd: token.marginXS,
    fontSize: token.controlHeight
  }), _extends2))), _defineProperty(_ref, componentCls + "-borderless", {
    borderColor: 'transparent'
  }), _ref;
};
export default genComponentStyleHook('QRCode', function (token) {
  return genQRCodeStyle(mergeToken(token, {
    QRCodeMaskBackgroundColor: 'rgba(255, 255, 255, 0.96)'
  }));
});